/**
 * Extract and normalize subdomain from the current hostname.
 * e.g. "cat.medispace.app" -> "cat", "demo.medispace.app" -> "demo"
 * "localhost" or single-part hostname -> "demo" (default).
 */
export function getSubdomainFromHostname(hostname: string): string {
  if (typeof hostname !== 'string' || !hostname) {
    return 'demo';
  }
  const normalized = hostname.toLowerCase().trim();
  const parts = normalized.split('.').filter(Boolean);
  // Single part (localhost, etc.) or no subdomain (e.g. "medispace.app" with no subdomain)
  if (parts.length <= 1) {
    return 'demo';
  }
  // First part is subdomain (e.g. cat.medispace.app -> cat)
  const subdomain = parts[0];
  return subdomain === 'www' ? 'demo' : subdomain;
}

/**
 * Paths that do NOT require X-Tenant-ID per backend contract.
 * Request URL is relative to axios baseURL (e.g. /api/v1), so we match relative path.
 */
const TENANT_HEADER_EXCLUDED_PATHS = [
  '/health',
  '/actuator/health',
  '/api-docs',
  '/swagger-ui',
  '/swagger',
  '/admin',
];

export function isTenantHeaderRequired(url: string | undefined): boolean {
  if (!url) return true;
  const path = url.split('?')[0];
  const normalized = path.toLowerCase().trim();
  for (const excluded of TENANT_HEADER_EXCLUDED_PATHS) {
    if (normalized === excluded || normalized.startsWith(`${excluded}/`)) {
      return false;
    }
  }
  return true;
}
